import { Language } from 'assets/locales/Locale';
import { combineStrings } from 'assets/utils/data/String';
import { compact } from 'lodash';
import LossCodeCategory from 'models/claims/lossCodeCategory/Model.LossCodeCategory';
import Model from 'models/Model';
import lossCodeDeleteApi from './delete/Api.LossCode.Delete';
import lossCodeListApi from './list/Api.LossCode.List';
import lossCodeSaveApi from './save/Api.LossCode.Save';

export default class LossCode
  extends Model<Model.ILossCode>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.ILossCode>
{
  id: number;
  code: string;
  category: string;
  descnEn: string;
  descFr: string;
  notes: string;
  sectionCode: string;
  isInternalOnly: boolean;
  isDisabled: boolean;
  lossCodeCategories?: LossCodeCategory[];

  constructor(data: Partial<Model.ILossCode> | Utils.FormData<Model.ILossCode>, language?: Locale.Languages) {
    super({ lossCodeCategories: [LossCodeCategory] }, language);
    this.update(data);
  }
  get categoryNames(): string[] {
    const names = compact(
      this.lossCodeCategories?.map((it) => (this._language === Language.french ? it?.nameFr : it?.nameEn))
    );
    return names.length ? names : compact([this.category]);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this._language === Language.french ? this.descFr : this.descnEn || this.id.toString(),
      info: combineStrings(' - ', this.code, this.categoryNames.join(', ')),
      subtitle: this.notes,
    };
  }
  static async list(body?: Api.Core.LossCode.List.IRequest) {
    const { payload, ...rest } = await lossCodeListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new LossCode(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await lossCodeSaveApi(this);
  }
  async delete() {
    return await lossCodeDeleteApi(this.id);
  }
}
